// Angular imports
import { Component, Input, ViewChild, AfterViewInit } from '@angular/core';

// 3rd party imports
import { DxChartComponent } from 'devextreme-angular';

// Component imports
import { MPBaseChartComponent } from '../../../_base/mp-base-chart.component';

// Service imports
import { ScreenService } from './../../../_services/shared-services/screen.service';
import { HelperService } from './../../../_services/shared-services/helper.service';
import { ContextManagerService } from '../../../_services/data-services/context-manager.service';
import { UserService } from '../../../_services/data-services/user.service';

// Model imports
import { ConveyanceResultDto } from '../../_models/conveyance-result-dto';

@Component({
    selector: 'app-conveyance-bar-chart',
    templateUrl: './conveyance-bar-chart.component.html',
    styleUrls: ['./conveyance-bar-chart.component.scss']
})
export class ConveyanceBarChartComponent extends MPBaseChartComponent implements AfterViewInit {
    @ViewChild(DxChartComponent, { static: false }) barChart: DxChartComponent;

    @Input() palette: string;
    @Input() paletteMode: string;
    @Input() chartData: ConveyanceResultDto[];

    conveyanceChartData: ConveyanceResultDto[];
    conveyanceChartPalette: string | string[];
    conveyanceChartTitle = 'Property Conveyance Activity: Trailling 12 - Months';
    conveyanceChartSubTitle = '(Based on Process Dates)';

    isHomwOwnerToHomeOwner = true;
    isHomwOwnerToDeclarant = true;
    isHomwOwnerToBuilder = true;
    isDeclarantToDeclarant = true;
    isDeclarantToHomeOwner = true;
    isDeclarantToBuilder = true;
    isBuilderToBuilder = true;
    isBuilderToHomeOwner = true;
    isBuilderToDeclarant = true;

    constructor(
        protected readonly screenService: ScreenService,
        protected contextManagerService: ContextManagerService,
        protected helperService: HelperService,
        protected userService: UserService
    ) {
        super(screenService, contextManagerService, helperService, userService);
    }

    ngAfterViewInit(): void {
        setTimeout(() => this.bindChartData(this.chartData), 100);
    }

    exportFileName = (): string => {
        return this.getExportFileName(this.conveyanceChartTitle);
    };

    private bindChartData(data?: ConveyanceResultDto[]): void {
        if (!data || data.length === 0) {
            const empty = new ConveyanceResultDto();
            empty.period = 'No Data';
            empty.builderToBuilder = 0;
            empty.builderToDeclarant = 0;
            empty.builderToHomeOwner = 0;
            empty.declarantToBuilder = 0;
            empty.declarantToDeclarant = 0;
            empty.declarantToHomeOwner = 0;
            empty.homwOwnerToBuilder = 0;
            empty.homwOwnerToDeclarant = 0;
            empty.homwOwnerToHomeOwner = 0;
            data = [empty];
            this.conveyanceChartPalette = ['#ccc'];
        }
        this.conveyanceChartData = data;

        this.isHomwOwnerToHomeOwner =
            this.conveyanceChartData.map((v) => v.homwOwnerToHomeOwner).reduce((p, n) => p + n) === 0 ? false : true;
        this.isHomwOwnerToDeclarant =
            this.conveyanceChartData.map((v) => v.homwOwnerToDeclarant).reduce((p, n) => p + n) === 0 ? false : true;
        this.isHomwOwnerToBuilder =
            this.conveyanceChartData.map((v) => v.homwOwnerToBuilder).reduce((p, n) => p + n) === 0 ? false : true;
        this.isDeclarantToDeclarant =
            this.conveyanceChartData.map((v) => v.declarantToDeclarant).reduce((p, n) => p + n) === 0 ? false : true;
        this.isDeclarantToHomeOwner =
            this.conveyanceChartData.map((v) => v.declarantToHomeOwner).reduce((p, n) => p + n) === 0 ? false : true;
        this.isDeclarantToBuilder =
            this.conveyanceChartData.map((v) => v.declarantToBuilder).reduce((p, n) => p + n) === 0 ? false : true;
        this.isBuilderToBuilder =
            this.conveyanceChartData.map((v) => v.builderToBuilder).reduce((p, n) => p + n) === 0 ? false : true;
        this.isBuilderToHomeOwner =
            this.conveyanceChartData.map((v) => v.builderToHomeOwner).reduce((p, n) => p + n) === 0 ? false : true;
        this.isBuilderToDeclarant =
            this.conveyanceChartData.map((v) => v.builderToDeclarant).reduce((p, n) => p + n) === 0 ? false : true;

        setTimeout(() => {
            this.chart = this.barChart;
            this.setChartSize();
        }, 250);
    }
}
